import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '@reducers/index';
import { GMBActions } from '@actions/index';
import { GoogleBusiness } from '@models/index';

@Injectable({
  providedIn: 'root'
})
export class GMBFacadeService {
  constructor (
    private store: Store<fromApp.State>
  ) { }

  getError$(): Observable<{ message: string | null, error: any | null } | null> {
    return this.store.select(fromApp.getGMBError);
  }

  getBusinesses$(): Observable<GoogleBusiness[] | false | null> {
    return this.store.select(fromApp.getGMBBusinesses);
  }

  searchBusinesses() {
    this.store.dispatch(GMBActions.searchGoogleBusinessesByCurrentUser());
  }

  refreshBusinesses() {
    this.store.dispatch(GMBActions.refreshBusinesses());
  }

  getIsExecuting$(): Observable<boolean> {
    return this.store.select(fromApp.getIsGMBExecuting);
  }

  authenticateWithGoogle(code: string | null) {
    return this.store.dispatch(GMBActions.authenticateWithGoogle({ code }));
  }

  clearError(){
    return this.store.dispatch(GMBActions.error(null))
  }
}
